import type { PatchRelease } from "../types";

export const release: PatchRelease = {
  id: "2026-06-30_01",
  version: "2026.06.30",
  date: "30 Jun 2026",
  sinceCommit: "8f7726b",
  gameplay: [
    {
      text: "**Bugfix:** Skill points ar no longer granted after spell slots are full.",
    },
    {
      text: "Classic and PvE shops let you **plan picks before Ready** — toggle spells and passives into a tentative loadout, then commit everything when you lock in.",
    },
    {
      text: "Bosses, boss adds, and bots now treat an illusion decoy as the real wizard.",
    },
    {
      text: "You can no longer see and **spectate your own matches** after leaving a game.",
    },
    {
      text: "**Registering:** Sign in with **Discord** support added. Email/password sign-in removed.",
    },
    {
      text: "Arena platform and stone pillars redesigned.",
    },
    {
      text: "Explosions **scorch the arena floor**, leaving craters and burn marks after the impact.",
    },
  ],
  skills: [
    {
      spellId: "teleport",
      changes: [
        {
          text: "Cooldown **24s → 18s**",
        },
        {
          text: "Teleport's Quick Blink: cooldown reduction **−5s → −7s**",
          passiveId: "teleport_cooldown",
        },
      ],
    },
    {
      spellId: "thrust",
      changes: [
        {
          text: "Cooldown **32s → 8s**\nDash distance **320 → 1000**",
        },
      ],
    },
    {
      spellId: "rush",
      changes: [
        {
          text: "Cooldown **40s → 15s**",
        },
      ],
    },
    {
      spellId: "shield",
      changes: [
        {
          text: "Cooldown **44s → 20s**",
        },
      ],
    },
    {
      spellId: "barrier",
      changes: [
        {
          text: "Cooldown **32s → 20s**",
        },
      ],
    },
    {
      spellId: "reflect",
      changes: [
        {
          text: "Cooldown **42s → 22s**",
        },
      ],
    },
    {
      spellId: "timeshift",
      changes: [
        {
          text: "Cooldown **56s → 20s**",
        },
      ],
    },
    {
      spellId: "blizzard",
      changes: [
        {
          text: "Blizzard's Rime Shards: tick damage bonus **+40% → +14 tick damage**",
          passiveId: "blizzard_damage",
        },
      ],
    },
    {
      spellId: "hook",
      changes: [
        {
          text: "Hook's Barbed Hook: damage bonus **2× → +50 damage**",
          passiveId: "hook_damage",
        },
      ],
    },
    {
      spellId: "illusionist",
      changes: [
        {
          text: "Extra decoys now come from the **Mirror Army** passive only — spell upgrades no longer add copies.",
        },
        {
          text: "New passives **Long Mirage** (+1s decoy duration) and **Vanishing Act** (+12 HP on cast).",
        },
      ],
    },
    {
      spellId: "bonespear",
      changes: [
        {
          text: "New passive tree: Splintered Bone (+24 damage), Quick Cast (−2.5s cooldown), Piercing Force (+28 knock), Deadly Throw (+180 projectile speed).",
        },
      ],
    },
    {
      spellId: "chainmend",
      changes: [
        {
          text: "New passive **Linked Tide**: +1 chain hop.",
          passiveId: "chainmend_surge",
        },
        {
          text: "Chain Mend's Overflow: healing bonus **+20% → +9 healing**",
          passiveId: "chainmend_heal",
        },
      ],
    },
  ],
};
